import store from "@/store";

const isDirectorAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");

  if (store.getters.isDirectorAuthenticated && access_token) {
    next("/director/main");
  } else {
    next();
  }
};
const isFuneralAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");
  if (store.getters.isFuneralAuthenticated && access_token) {
    next("/funeral/main");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Login"
    },
    path: "/login",
    name: "Login",

    component: () => import("@/views/login/Login.vue")
  },
  // 장례 지도사 로그인
  {
    meta: {
      title: "LoginDo"
    },
    path: "/director/loginDo",
    name: "LoginDo",
    beforeEnter: isDirectorAuth,
    component: () => import("@/views/director/login/LoginDo.vue")
  },

  //
  {
    meta: {
      title: "LoginDo"
    },
    path: "/funeral/loginDo",
    name: "LoginDo",
    beforeEnter: isFuneralAuth,
    component: () => import("@/views/funeral/login/LoginDo.vue")
  },

  // 상조(관리자) 로그인
  {
    meta: {
      title: "LoginDo"
    },
    path: "/corp/loginDo",
    name: "LoginDo",
    // beforeEnter: isFuneralAuth,
    component: () => import("@/views/corp/login/LoginDo.vue")
  },
  {
    meta: {
      title: "JoinFuneral"
    },
    path: "/JoinFuneral",
    name: "JoinFuneral",
    component: () => import("@/views/login/JoinFuneral.vue")
  },
  {
    meta: {
      title: "JoinSolo"
    },
    path: "/joinSolo",
    name: "JoinSolo",
    component: () => import("@/views/login/JoinSolo.vue")
  },
  {
    meta: {
      title: "SearchId"
    },
    path: "/searchId",
    name: "SearchId",
    component: () => import("@/views/login/SearchId.vue")
  },
  {
    meta: {
      title: "SearchPw"
    },
    path: "/searchPw",
    name: "SearchPw",
    component: () => import("@/views/login/SearchPw.vue")
  }
];
